var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCheckmarkSpiked = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 61,
    viewBox: "0 0 59 61",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark-spiked",
    clipPath: "url(#clip0_6028_70509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.62 30.5L58.5736 22.5L50.4328 18.1L50.8552 8.58L41.716 9.02L37.4536 0.5L29.7736 5.66L22.0552 0.5L17.8312 8.98L8.65363 8.54L9.07603 18.06L0.973633 22.5L5.88883 30.5L0.973633 38.54L9.07603 42.94L8.65363 52.46L17.7928 52.02L22.0552 60.5L29.7352 55.38L37.4536 60.5L41.6776 52.02L50.8168 52.5L50.3944 42.98L58.5736 38.54L53.62 30.5ZM44.5576 23.34C44.404 24.1 44.0584 24.78 43.5208 25.3C37.108 32.02 34.3432 33.78 27.7384 40.66C27.0856 41.34 26.2024 41.74 25.3192 41.78C24.3976 41.82 23.5144 41.5 22.7848 40.9L14.8744 33.9C14.4904 33.58 14.1832 33.18 13.9528 32.74C13.7224 32.3 13.5688 31.82 13.5304 31.3C13.492 30.78 13.5304 30.3 13.684 29.78C13.8376 29.26 14.068 28.86 14.3752 28.46C14.6824 28.06 15.0664 27.74 15.5272 27.54C15.9496 27.3 16.4488 27.18 16.9096 27.14C17.4088 27.14 17.8696 27.14 18.3304 27.34C18.7912 27.5 19.2136 27.78 19.5976 28.1L24.8968 32.78C30.1192 27.22 32.6152 25.9 38.3368 19.94C38.9896 19.22 39.9112 18.82 40.8328 18.78C41.5624 18.78 42.292 18.98 42.9064 19.38C43.5208 19.78 44.02 20.38 44.2888 21.1C44.5576 21.82 44.6344 22.58 44.5192 23.34H44.5576Z",
    fill: "url(#paint0_linear_6028_70509)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6028_70509",
    x1: 51.8344,
    y1: 8.9,
    x2: 7.15253,
    y2: 53.6972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#5A49A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716146,
    stopColor: "#8A65EB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6028_70509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.6,
    height: 60,
    fill: "white",
    transform: "translate(0.973633 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckmarkSpiked, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checkmark-spiked.d9d362a3.svg";
export { ForwardRef as ReactComponent };